/* eslint-disable */
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer } from '../runtime.js';

const de_profile__tabs__settings__vehicle = /** @type {(inputs: {}) => string} */ () => {
	return `Ihr Fahrzeug`
};

const en_profile__tabs__settings__vehicle = /** @type {(inputs: {}) => string} */ () => {
	return `Your vehicle`
};

const es_profile__tabs__settings__vehicle = /** @type {(inputs: {}) => string} */ () => {
	return `Tu vehículo`
};

const fr_profile__tabs__settings__vehicle = /** @type {(inputs: {}) => string} */ () => {
	return `Votre véhicule`
};

const it_profile__tabs__settings__vehicle = /** @type {(inputs: {}) => string} */ () => {
	return `Il tuo veicolo`
};

const nl_profile__tabs__settings__vehicle = /** @type {(inputs: {}) => string} */ () => {
	return `Uw voertuig`
};

const pt_profile__tabs__settings__vehicle = /** @type {(inputs: {}) => string} */ () => {
	return `O seu veículo`
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{}} inputs
* @param {{ locale?: "de" | "en" | "es" | "fr" | "it" | "nl" | "pt" }} options
* @returns {string}
*/
/* @__NO_SIDE_EFFECTS__ */
export const profile__tabs__settings__vehicle = (inputs = {}, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.profile__tabs__settings__vehicle(inputs) 
	}
	const locale = options.locale ?? getLocale()
	trackMessageCall("profile__tabs__settings__vehicle", locale)
	if (locale === "de") return de_profile__tabs__settings__vehicle(inputs)
	if (locale === "en") return en_profile__tabs__settings__vehicle(inputs)
	if (locale === "es") return es_profile__tabs__settings__vehicle(inputs)
	if (locale === "fr") return fr_profile__tabs__settings__vehicle(inputs)
	if (locale === "it") return it_profile__tabs__settings__vehicle(inputs)
	if (locale === "nl") return nl_profile__tabs__settings__vehicle(inputs)
	return pt_profile__tabs__settings__vehicle(inputs)
};